import { render, staticRenderFns } from "./CardLost.vue?vue&type=template&id=2f3f3b42&"
import script from "./CardLost.vue?vue&type=script&lang=js&"
export * from "./CardLost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports